import { useQuery } from '@tanstack/react-query';
import { OilStoreTypeService } from 'services/openapi';
import { OilStoreTypeQueryKeys } from './constants';

type GetOilStoreTypesDTO = {
  fetchData?: number;
};

export const useGetOilStoreTypesQuery = (variables?: GetOilStoreTypesDTO) => {
  return useQuery({
    queryKey: [OilStoreTypeQueryKeys.GET_OIL_STORE_TYPES, variables],
    queryFn: () => OilStoreTypeService.oilStoreTypeControllerGetAll(),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
};
